import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Banner from 'components/Banner';
import DistributionContacts from 'components/DistributionContacts';
import bannerImage from 'images/contacts-banner.jpg';
import { CTAFormSection } from 'components/formSections/CTAFormSection';
import ContactsCards from './ContactsCards';

const Contacts = () => {
    return (
        <div className="container">
            <Banner title="Contacts" image={bannerImage} buttonText="Contact us" />
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>We’re international</LabelButton>
                    <GradientText>
                        UniferX is growing rapidly <br /> in <em>Germany, Ukraine, Moldova & Kazakhstan</em>
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="super-small">
                            Our professional team is always open for communication and ready to help you solve any
                            issue!
                        </GradientText>
                    </div>
                </div>
            </div>
            <DistributionContacts />
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>Contacts</LabelButton>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="middle">
                            Service center for <em>Eastern Europe and Central Asia:</em>
                        </GradientText>
                    </div>
                </div>
                <ContactsCards />
            </div>
            <CTAFormSection />
        </div>
    );
};

export default Contacts;
